import { Activity, ActivityConnection, ActivityConnectionInput, SortDirectionEnum } from '../../../models/gen/graphql';
import { ConnectionDetails, QueryInputType, convertConnectionToDetails, handleError, queryInput } from '../../../utils/custom';

import { DocumentNode } from 'graphql';
import { GraphApiResponse } from '../../core';
import { SearchActivityDocument } from '@/api/queries';
import createGraphApiHook from '../../../hooks/createGraphApiHook';
import gql from 'graphql-tag';
import graphApi from '../..';

export type SearchActivityGraphApiResponse = GraphApiResponse<typeof SearchActivityDocument>;
export const searchActivityResponseSelector = (res: SearchActivityGraphApiResponse): ConnectionDetails<Activity> =>
  convertConnectionToDetails(res?.searchActivity?.activityConnection as ActivityConnection);

const [, runRefetchSearchActivity] = graphApi(SearchActivityDocument, {
  onError: (res: SearchActivityGraphApiResponse): void => handleError(res, { notification: { title: 'Search Activity' } }),
});

export const getActivityByTripId = async (tripId: string, timezoneOffset?: string): Promise<Activity[]> => {
  const input: ActivityConnectionInput = {
    first: 1000,
    after: null,
    query: [
      {
        tripId: queryInput(tripId),
        createdAt: queryInput(null, QueryInputType.DEFAULT, SortDirectionEnum.Desc),
      },
    ],
    offset: timezoneOffset,
  };

  const res = await runRefetchSearchActivity({ input });
  const conn = searchActivityResponseSelector(res);

  return conn.rows;
};
export const useGetActivityForTrip = createGraphApiHook(getActivityByTripId);

export enum ActivityType {
  COMBINE_RULE_HISTORY = 'CombineRuleHistory',
  INVOICE = 'Invoice',
}

type ActivityConfig = {
  key: string;
  queryName: string;
  searchName: string;
  connectionName: string;
  inputType: string;
};

const ACTIVITY_CONFIG: Record<ActivityType, ActivityConfig> = {
  [ActivityType.INVOICE]: {
    key: 'invoice',
    queryName: 'SearchInvoice',
    searchName: 'searchInvoices',
    connectionName: 'invoiceActivityConnection',
    inputType: 'InvoiceActivityConnectionInput',
  },
  [ActivityType.COMBINE_RULE_HISTORY]: {
    key: 'combineRuleHistory',
    queryName: 'SearchCombineRuleHistory',
    searchName: 'searchCombineRuleHistory',
    connectionName: 'combineRuleHistoryActivityConnection',
    inputType: 'CombineRuleHistoryActivityConnectionInput',
  },
};

export const getActivityConfig = (type: ActivityType): ActivityConfig => ACTIVITY_CONFIG[type];

export const generateSearchActivityQuery = (type: ActivityType): DocumentNode => {
  const { queryName, searchName, connectionName, inputType } = getActivityConfig(type);
  return gql`
  query ${queryName}($input: ${inputType}) {
    ${searchName} {
      ${connectionName}(input: $input) {
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            action
            createdAt
            createdBy
            createdByFirstName
            createdByLastName
            displayMessage
            field
            formerValue
            id
            message
            namespace
            resource
            resourceId
            updatedAt
            updatedBy
            value
            parentNamespace
            parentResource
            parentResourceId
            platformName
          }
        }
      }
    }
  }
`;
};
